import { AuthProgressState } from '../defaults/authProgress';

export const SET_EMAIL_ADDRESS = 'APP_AUTH_SET_EMAIL_ADDRESS';
export const SET_PHONE_NUMBER = 'APP_SET_PHONE_NUMBER';
export const SET_IS_REGISTERING = 'APP_SET_IS_REGISTERING';
export const SET_IS_EMAIL_AUTHENTICATION = 'APP_SET_IS_EMAIL_AUTHENTICATION';
export const SET_IS_EMAIL_REGISTRATION = 'SET_IS_EMAIL_REGISTRATION';
export const SET_RESTART_LINK_PATH = 'APP_SET_RESTART_LINK_PATH';
export const UPDATE_AUTH_PROGRESS = 'APP_UPDATE_AUTH_PROGRESS';
export const SET_AUTH_MESSAGE = 'APP_SET_AUTH_MESSAGE';

export interface SetEmailAddressAction {
  type: typeof SET_EMAIL_ADDRESS;
  emailAddress: string;
}

export function setEmailAddress(emailAddress: string): SetEmailAddressAction {
  return {
    type: SET_EMAIL_ADDRESS,
    emailAddress,
  };
}

export interface SetPhoneNumberAction {
  type: typeof SET_PHONE_NUMBER;
  phoneNumber: string;
}

export function setPhoneNumber(phoneNumber: string): SetPhoneNumberAction {
  return {
    type: SET_PHONE_NUMBER,
    phoneNumber,
  };
}

export interface SetIsRegisteringAction {
  type: typeof SET_IS_REGISTERING;
  isRegistering: boolean;
}

export function setIsRegistering(isRegistering: boolean): SetIsRegisteringAction {
  return {
    type: SET_IS_REGISTERING,
    isRegistering,
  };
}

export interface SetIsEmailRegistrationAction {
  type: typeof SET_IS_EMAIL_REGISTRATION;
  isEmailRegistration: boolean;
}

export function setIsEmailRegistration(isEmailRegistration: boolean): SetIsEmailRegistrationAction {
  return {
    type: SET_IS_EMAIL_REGISTRATION,
    isEmailRegistration,
  };
}

export interface SetIsEmailAuthenticationAction {
  type: typeof SET_IS_EMAIL_AUTHENTICATION;
  isEmailAuthentication: boolean;
}

export function setIsEmailAuthentication(
  isEmailAuthentication: boolean,
): SetIsEmailAuthenticationAction {
  return {
    type: SET_IS_EMAIL_AUTHENTICATION,
    isEmailAuthentication,
  };
}

export interface SetRestartLinkPathAction {
  type: typeof SET_RESTART_LINK_PATH;
  restartLinkPath: string;
}

export function setRestartLinkPath(restartLinkPath: string): SetRestartLinkPathAction {
  return {
    type: SET_RESTART_LINK_PATH,
    restartLinkPath,
  };
}

export interface UpdateAuthProgressAction {
  type: typeof UPDATE_AUTH_PROGRESS;
  payload: Partial<AuthProgressState>;
}

export function updateAuthProgress(
  authProgress: Partial<AuthProgressState>,
): UpdateAuthProgressAction {
  return {
    type: UPDATE_AUTH_PROGRESS,
    payload: authProgress,
  };
}
